import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const ConfirmButton = ({ children, title, description, onConfirm, className, testId, disabled }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button type="button" data-testid={testId} disabled={disabled} className={className}>{children}</button>
    </AlertDialogTrigger>
    <AlertDialogContent className="border-[#1E2D4A] bg-[#0B1120]">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display uppercase tracking-wider">{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
        <AlertDialogAction data-testid={`${testId}-confirm`} onClick={onConfirm}>Confirm</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
